import React from "react";
import styled, { keyframes } from "styled-components";
import {
  FaReact,
  FaNodeJs,
  FaDocker,
  FaAws,
  FaDatabase,
  FaMobileAlt,
  FaBrain,
  FaGithub,
} from "react-icons/fa";
import {
  SiNestjs,
  SiApachekafka,
  SiKubernetes,
  SiMongodb,
  SiPostgresql,
  SiGraphql,
  SiGoland,
  SiJenkins,
  SiPython,
  SiTypescript,
  SiNextdotjs,
  SiTensorflow,
  SiGithubactions,
} from "react-icons/si";

/* --- Animations --- */
const fadeUp = keyframes`
  0% { transform: translateY(20px); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
`;

const Section = styled.section`
  background: black;
  padding: 4rem 1rem;
  text-align: center;
  color: white;
`;

const Title = styled.h2`
  font-size: 2.4rem;
  font-weight: 700;
  background: linear-gradient(90deg, #ff7a18, #ff0066);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 2.5rem;
`;

const CategoriesWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
`;

const CategoryCard = styled.div`
  flex: 1;
  min-width: 250px;
  max-width: 300px;
  background: rgba(255, 255, 255, 0.05);
  padding: 2rem;
  border-radius: 18px;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
  animation: ${fadeUp} 0.6s ease forwards;
  opacity: 0;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-8px) scale(1.05);
    box-shadow: 0 0 25px rgba(255, 122, 24, 0.3),
      0 0 40px rgba(255, 0, 102, 0.25);
  }
`;

const CategoryTitle = styled.h3`
  font-size: 1.4rem;
  margin-bottom: 1.2rem;
  color: #fff;
`;

const TechGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));
  gap: 1rem;
  justify-items: center;
`;

const TechIcon = styled.div`
  font-size: 2.2rem;
  background: linear-gradient(135deg, #ff7a18, #ff0066);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export default function TechnologiesSection() {
  const categories = [
    {
      title: "Frontend",
      tech: [<FaReact />, <SiNextdotjs />, <FaMobileAlt />, <FaGithub />],
    },
    {
      title: "Backend",
      tech: [
        <FaNodeJs />,
        <SiNestjs />,
        <SiApachekafka />,
        <SiGoland />,
        <SiTypescript />,
      ],
    },
    {
      title: "Database",
      tech: [<SiMongodb />, <SiPostgresql />, <FaDatabase />, <SiGraphql />],
    },
    {
      title: "Cloud & DevOps",
      tech: [
        <FaAws />,
        <FaDocker />,
        <SiKubernetes />,
        <SiJenkins />,
        <SiGithubactions />,
      ],
    },
    {
      title: "AI & Data",
      tech: [<FaBrain />, <SiPython />, <SiTensorflow />],
    },
  ];

  return (
    <Section>
      <Title>Technologies I Work With</Title>
      <CategoriesWrapper>
        {categories.map((cat, index) => (
          <CategoryCard
            key={index}
            style={{ animationDelay: `${index * 0.15}s` }}
          >
            <CategoryTitle>{cat.title}</CategoryTitle>
            <TechGrid>
              {cat.tech.map((icon, idx) => (
                <TechIcon key={idx}>{icon}</TechIcon>
              ))}
            </TechGrid>
          </CategoryCard>
        ))}
      </CategoriesWrapper>
    </Section>
  );
}
